import { Fragment } from "react";
import { styled } from "@mui/material/styles";
import AdSlot from "@pageContent/AdSlot";
import { AD_IDS } from "@constants/consts";
import { RootNode } from "@typings/richText";
import { documentToReactComponents } from "@utils/pageContent/richTextToJSX";

const RichTextWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(4),
  marginTop: theme.spacing(4),
  [theme.breakpoints.up("md")]: {
    gap: theme.spacing(6),
  },
}));

const RichText: React.FC<{ richText: RootNode; shouldDisplayAd?: boolean }> = ({ richText, shouldDisplayAd }) => {
  return (
    <RichTextWrapper>
      {documentToReactComponents(richText).map((Item, index) => {
        return (
          <Fragment key={index}>
            {index === 1 && shouldDisplayAd && <AdSlot id={AD_IDS.contentBanner} />}
            {Item}
          </Fragment>
        );
      })}
    </RichTextWrapper>
  );
};

export default RichText;
